/** Tesis detay (reportpages) ve Yeni Tesis ekle üst bar / sayfa zemini — tek kaynak */
export const reportUi = {
    headerBg: 'hsl(192 71% 17%)',
    footerBg: 'hsl(192 62% 20%)',
    pageBg: 'hsl(192 24% 95%)',
    surface: 'hsl(0 0% 100%)',
    surfaceSoft: 'hsl(192 28% 92%)',
    primary: 'hsl(192 70% 28%)',
    primaryHover: 'hsl(192 74% 24%)',
    textMain: 'hsl(192 46% 18%)',
    textMuted: 'hsl(192 20% 38%)',
    border: 'hsl(192 24% 82%)',
    accent: 'hsl(192 42% 62%)',
    headerSubtext: 'hsl(192 32% 82%)',
    radius: '6px',
} as const;
